export default "__VITE_ASSET__MGL7zWkF__"